import { render, staticRenderFns } from "./CalendarCustom.vue?vue&type=template&id=35b4cfae&"
import script from "./CalendarCustom.vue?vue&type=script&lang=js&"
export * from "./CalendarCustom.vue?vue&type=script&lang=js&"
import style0 from "./CalendarCustom.vue?vue&type=style&index=0&id=35b4cfae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports